import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class UsersService {
  constructor(private http: HttpClient) {}

  setBlockingIncomingCalls(userId: number, block: boolean) {
    return this.http.put(`/users/${userId}/set-blocking-incoming-calls?block=${block}`, {});
  }
}
